import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "@/services/API";

const initialState = {
  pickupLocation: {
    data: null,
    loading: false,
    error: null,
  },
  deliveryLocation: {
    data: null,
    loading: false,
    error: null,
  },
  pickupMarketCenter: {
    data: null,
    loading: false,
    error: null,
  },
  deliveryMarketCenter: {
    data: null,
    loading: false,
    error: null,
  },
};

export const getPickupLocation = createAsyncThunk("search/get-pickup-location", async ({ zip }, { rejectWithValue }) => {
  return API.get("/search/location", {
    params: {
      zip,
    },
  })
    .then((response) => {
      return {
        countryCode: response.countryCode,
        latitude: response.latitude,
        longitude: response.longitude,
        placeName: response.placeName,
        stateCode: response.stateCode,
        zip: response.zip,
        market: response.market,
      };
    })
    .catch((error) => rejectWithValue(error));
});
export const getDeliveryLocation = createAsyncThunk("search/get-delivery-location", async ({ zip }, { rejectWithValue }) => {
  return API.get("/search/location", {
    params: {
      zip,
    },
  })
    .then((response) => {
      return {
        countryCode: response.countryCode,
        latitude: response.latitude,
        longitude: response.longitude,
        placeName: response.placeName,
        stateCode: response.stateCode,
        zip: response.zip,
        market: response.market,
      };
    })
    .catch((error) => rejectWithValue(error));
});

const searchSlice = createSlice({
  name: "searchSelected",
  initialState,
  reducers: {
    setSearchType: (state, action) => {
      state.params.searchType = action.payload;
    },
    clearSearchState: () => {
      return initialState;
    },
    clearLocations: (state) => {
      state.pickupLocation = initialState.pickupLocation;
      state.deliveryLocation = initialState.deliveryLocation;
      state.pickupMarketCenter = initialState.pickupMarketCenter;
      state.deliveryMarketCenter = initialState.deliveryMarketCenter;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getPickupLocation.pending, (state) => {
        state.pickupLocation = {
          data: null,
          loading: true,
          error: null,
        };
      })
      .addCase(getPickupLocation.fulfilled, (state, action) => {
        state.pickupLocation = {
          data: action.payload,
          loading: false,
          error: null,
        };
      })
      .addCase(getPickupLocation.rejected, (state) => {
        state.pickupLocation = {
          data: null,
          loading: false,
          error: "Error getting pickup location",
        };
      })
      .addCase(getDeliveryLocation.pending, (state) => {
        state.deliveryLocation = {
          data: null,
          loading: true,
          error: null,
        };
      })
      .addCase(getDeliveryLocation.fulfilled, (state, action) => {
        state.deliveryLocation = {
          data: action.payload,
          loading: false,
          error: null,
        };
      })
      .addCase(getDeliveryLocation.rejected, (state) => {
        state.deliveryLocation = {
          data: null,
          loading: false,
          error: "Error getting delivery location",
        };
      });
  },
});

export const { clearSearchState, clearLocations, setSearchType } = searchSlice.actions;
export default searchSlice.reducer;
